import React, { useState } from "react"
import { Link } from "react-router-dom"

import { contracts } from "../../Pages/NFTSale/utils"
import { networkIcons } from "../../utils"
import "./NftCard.scss"

const NftCard = ({ nft, idx, subdomain, enableClickNFT = true, contractType }) => {
    // if enableClickNFT == true, clicking on this component will redirect to nft details page

    const collectionAddress = contracts[subdomain]?.[contractType]?.address
    const chain = contracts[subdomain]?.network
    const contractOwner = contracts[subdomain]?.[contractType]?.owner
    const collectionSymbol = contracts[subdomain]?.[contractType]?.symbol

    const [showImageLoading, setShowImageLoading] = useState(true)

    return (
        <React.Fragment>
            <Link
                className={"nft-from-loot-box" + (enableClickNFT ? " show-background" : "")}
                to={{
                    pathname: `/tokendetails/${collectionAddress}/${nft?.tokenId}`,
                    state: {
                        nft,
                        subdomain,
                        idx,
                        enableClickNFT,
                        breadCrumbTitle: "Token Details",
                        contractAddress: collectionAddress,
                        chain,
                        contractOwner,
                        collectionSymbol
                    }
                }}
                key={idx}
            >
                <div className="nft-from-loot-box-card">
                    <div className="image-wrap">
                        {subdomain === "swordsofblood" && (
                            <img
                                src={nft?.imgUrl}
                                onLoad={() => setShowImageLoading(false)}
                                alt={subdomain + " nft from lootbox"}
                                className={"nft-img" + (showImageLoading ? " hide" : "")}
                            />
                        )}
                    </div>

                    <div className="nft-name">{nft?.name}</div>

                    <div className="nft-label description">Description:</div>
                    <div className="nft-val description">{nft?.description}</div>

                    <div className="nft-label token-id">
                        TokenId: <span>{nft?.tokenId}</span>
                    </div>

                    <div className="nft-label attributes">Attributes:</div>
                    {nft?.attributes
                        ? nft?.attributes?.map((item) => {
                              return (
                                  <div className="attribute-name">
                                      {item.trait_type} : {item.value}
                                  </div>
                              )
                          })
                        : null}
                </div>
            </Link>
        </React.Fragment>
    )
}

export default NftCard
